import { render, staticRenderFns } from "./music-player.vue?vue&type=template&id=19b99dc8&scoped=true"
import script from "./music-player.vue?vue&type=script&setup=true&lang=js"
export * from "./music-player.vue?vue&type=script&setup=true&lang=js"
import style0 from "./music-player.vue?vue&type=style&index=0&id=19b99dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b99dc8",
  null
  
)

export default component.exports